<template>
  <div>
    <StepDateAndPeople
      v-if="step === STEPS.dateAndPeople"
      @submit="submit"
    />

    <StepMessageAndCatering
      v-if="step === STEPS.messageAndCatering"
      :can-finish-enquiry="isLoggedInUser"
      @submit="submit"
      @back="setStep(STEPS.dateAndPeople)"
    />

    <StepUserInfo
      v-if="step === STEPS.userInfo"
      @submit="submit"
      @back="backFromUserInfo"
    />
  </div>
</template>

<script>
import StepDateAndPeople from './steps/StepDateAndPeople.vue';
import StepMessageAndCatering from './steps/StepMessageAndCatering.vue';
import StepUserInfo from './steps/StepUserInfo.vue';

export default {
  name: 'EnquiryForm',
  emits: ['openModal'],
  components: { StepUserInfo, StepMessageAndCatering, StepDateAndPeople },
  computed: {
    isLoggedInUser() {
      return this.$store.state.user.isLoggedIn;
    },
    step() {
      return this.$store.state.step;
    },
    STEPS() {
      return this.$store.state.STEPS;
    },
  },

  watch: {
    step: {
      handler(value) {
        if (value === this.STEPS.messageAndCatering) {
          this.$store.dispatch('trackGA4Interaction', {
            section: 'message',
            element: 'step',
            interaction: 'visible',
          });
        }
        if (value === this.STEPS.userInfo) {
          this.$store.dispatch('trackGA4Interaction', {
            section: 'signup',
            element: 'step',
            interaction: 'visible',
          });
        }
      },
      immediate: true,
    },
  },

  methods: {
    setStep(step) {
      this.$store.commit('setStep', step);
    },

    backFromUserInfo() {
      if (this.$store.state.requestToBookPath) {
        this.setStep(this.STEPS.dateAndPeople);
        return;
      }

      this.setStep(this.STEPS.messageAndCatering);
    },

    submit({ requestToBookPath } = { requestToBookPath: false }) {
      if (this.$store.getters.isRtbFlowPossible && this.step === this.STEPS.dateAndPeople) {
        this.$store.commit('setRequestToBookPath', !!requestToBookPath);

        if (requestToBookPath && this.isLoggedInUser) {
          this.$store.dispatch('sendEnquiry');
          return;
        }

        if (requestToBookPath && !this.isLoggedInUser) {
          this.$store.dispatch('requestToBookFlow');
          return;
        }
      }

      if (this.step === this.STEPS.dateAndPeople) {
        this.setStep(this.STEPS.messageAndCatering);
        return;
      }

      if (this.step === this.STEPS.messageAndCatering && !this.isLoggedInUser) {
        this.setStep(this.STEPS.userInfo);
        return;
      }

      this.$store.dispatch('sendEnquiry');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
